export const css = {
    root: 'EhcM-eI-',
    loading: '_3jDESX_e',
    titleBlock: '_1BiTyuec',
    title: '_2HHmfKIN',
    gotitBlock: '_3859Yuua',
    gotit: '_1YNKmTj_',
    section: '_3rrul10J',
    hero: '_1eTiaruj',
    heroBanner: 'HRhRQJmK',
    heroSubtitle: '_2JbLtZUQ',
    heroIconList: '_1MArbJgH',
    verticalAccordion: '_2oowwSl5',
    accordion: '_1hYaPnkz',
    horizontalAccordion: '_2VfQ5IR4',
    storyline: '_9SVUpSh0',
    xref: '_3ZgCt3a0',
    HCBullet: '_3YF200zk',
    HCBulletStyle2: '_1TT4o-5r',
    TableUL: '_2zv8ZycA',
    figure: '_1jdyqJHe',
    nextprev: '_1ksorMJH',
    next: '_3_E9LbCz',
    previous: '_3AotEj49',
    compactyes: '_2u2v9WKq',
    ' _key': 'apic-theme/apic/micro/book-widgets/topicpage'
};
export default css;
